import { MemberDatasource } from '../../global/datasources/member_datasource';
import { AccountDatasource } from '../datasources/account_datasource';
import { ICommand, IDefineCommand, IDatasource } from 'core-ts-types';

// hack to make GainSightPX global without clobbering the function
// tslint:disable-next-line
let aptrinsic: any;

angular.module('capability-ng-user-app').factory(
  'setUserTrackingInfoCommand',
  (
    defineCommandORM: IDefineCommand,
    ngAccountDatasource: AccountDatasource,
    ngMemberDatasource: MemberDatasource
  ): ICommand => {
    return defineCommandORM('setUserTrackingInfoCommand', function(deferred: ng.IDeferred<any>): void {
      const memberInfo = ngMemberDatasource.read().core_config;

      const {
        is_transfer_admin,
        is_application_admin,
        is_transfer_counselor,
        is_transfer_analytics_user,
        is_transfer_delivery,
        tracking_id
      } = ngAccountDatasource.read();

      if ('aptrinsic' in window && _.isFunction(window['aptrinsic'])) {
        const account = {
          id: location.hostname,
          name: memberInfo.full_name
        };

        const { isAnonymous } = ngAccountDatasource.read();

        const roles: string[] = [];

        if (is_transfer_admin) {
          roles.push('site_setup');
        }

        if (is_transfer_counselor) {
          roles.push('student_data');
        }

        if (is_transfer_analytics_user) {
          roles.push('analytics');
        }

        if (is_transfer_delivery) {
          roles.push('delivery');
        }

        if (is_application_admin) {
          roles.push('application_admin');
        }

        const { first_name, last_name, email } = !_.isEmpty(roles)
          ? ngAccountDatasource.read()
          : { first_name: undefined, last_name: undefined, email: undefined };

        const gainsightInfo = {
          id: tracking_id,
          is_anonymous: isAnonymous,
          roles: roles,
          firstName: first_name,
          lastName: last_name,
          email: email
        };

        (window as any)['aptrinsic']('identify', gainsightInfo, account);
      }
      deferred.resolve();
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/set_info_user_tracking_command.ts